import styles from './PageProductHeroCallToActionBasic.module.css';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import PageProductCallToActionBasicPrice from './PageProductCallToActionBasicPrice.js';
import PropTypes from 'prop-types';
import PageProductHeroLinkAuthFlow from './PageProductHeroLinkAuthFlow.js';
import LinkAuthFlow from './LinkAuthFlow.js';
import classNames from 'classnames';

function PageProductHeroCallToActionBasic({
  orTextColor,
  buttonCallToActionDisplay,
}) {
  const {
    callToActionDefaultText,
    callToActionHeroText,
    showHeroPrice,
    productSku,
    showPortfolioValuePropositionsSection,
  } = useSearchParamOrDefaultProps();

  const shouldShowPrice =
    showHeroPrice === 'true' && productSku !== 'RegisteredOnly';

  const callToActionText =
    callToActionHeroText || callToActionDefaultText || 'UPGRADE';

  const showPlusMessageDisclaimer = productSku === 'Plus';

  const isPortfolioPage = showPortfolioValuePropositionsSection === 'true';

  return (
    <div
      className={classNames(styles.PageProductHeroCallToActionBasic, {
        [styles.plusContainerLayout]: showPlusMessageDisclaimer,
        [styles.PageProductHeroCallToActionBasicPortfolio]: isPortfolioPage,
      })}
    >
      {showPlusMessageDisclaimer && (
        <div className={styles.plusDisclaimer}>
          CNBC+ currently available on cnbc.com and iOS & Android apps.
        </div>
      )}

      <PageProductHeroLinkAuthFlow
        fontWeight={600}
        boxShadow="0px 2px 4px 0px #00000040"
        fontSize="18px"
        lineHeight="18px"
        display="inline-block"
        borderStyle="solid"
        borderWidth="1px"
        borderRadius="5px"
        contentType={'page'}
        modalType={'signUp'}
        productSku={productSku}
        textAlign={'center'}
        letterSpacing="0.04em"
        flexGrow={0}
      >
        {callToActionText}
      </PageProductHeroLinkAuthFlow>

      {shouldShowPrice && (
        <PageProductCallToActionBasicPrice orTextColor={orTextColor} />
      )}

      {isPortfolioPage && (
        <div className={styles.signInButtonContainer}>
          <div className={styles.signInBtnSubText}>Already a subscriber?</div>
          <LinkAuthFlow
            className={styles.signInButton}
            product={'pro'}
            modalType={'signIn'}
            letterSpacing={'normal'}
            contentType={'livestream'}
          >
            Sign in
          </LinkAuthFlow>
        </div>
      )}
    </div>
  );
}

PageProductHeroCallToActionBasic.propTypes = {
  buttonCallToActionDisplay: PropTypes.string,
  orTextColor: PropTypes.string,
  color: PropTypes.string,
  showPrice: PropTypes.bool,
  isPageProductValueSummaries: PropTypes.bool,
};

export default PageProductHeroCallToActionBasic;
